
class SessionHelper {

    private readonly ACCESS_TOKEN_KEY = "AccessToken";
    private readonly REFRESH_TOKEN_KEY = "RefreshToken";
    private readonly TOKEN_EXPIRES_IN = "tokenExpiresIn";
    
    private readonly USERNAME = "UserName";
    private readonly API_URL = "ApiUrl";
    private readonly BRAND = "Brand";
    private readonly EMBEDDED_URL = "EmbeddedURL";
    private readonly USER_ARN = "UserArn";

    get accessToken(): string | undefined {
        return sessionStorage.getItem(this.ACCESS_TOKEN_KEY) ?? undefined;
    }

    set accessToken(accessToken: string | undefined) {
        if(!accessToken){
            sessionStorage.removeItem(this.ACCESS_TOKEN_KEY);
            return;
        }

        sessionStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
    }

    get refreshToken(): string | undefined {
        return sessionStorage.getItem(this.ACCESS_TOKEN_KEY) ?? undefined;
    }

    set refreshToken(refreshToken: string | undefined) {
        if(!refreshToken){
            sessionStorage.removeItem(this.REFRESH_TOKEN_KEY);
            return;
        }

        sessionStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);
    }

    get userName(): string | undefined {
        return sessionStorage.getItem(this.USERNAME) ?? undefined;
    }

    set userName(username: string | undefined) {
        if(!username){
            sessionStorage.removeItem(this.USERNAME);
            return;
        }

        sessionStorage.setItem(this.USERNAME, username);
    }

    get apiUrl(): string | undefined {
        return sessionStorage.getItem(this.ACCESS_TOKEN_KEY) ?? undefined;
    }

    set apiUrl(apiUrl: string | undefined) {
        if(!apiUrl){
            sessionStorage.removeItem(this.API_URL);
            return;
        }

        sessionStorage.setItem(this.API_URL, apiUrl);
    }

    get tokenExpiresIn(): number  {
        return Number(sessionStorage.getItem(this.TOKEN_EXPIRES_IN) ?? 0);
    }
    
    set tokenExpiresIn(expiresIn: number) {
        if(!expiresIn){
            sessionStorage.removeItem(this.TOKEN_EXPIRES_IN);
            return;
        }
        
        sessionStorage.setItem(this.TOKEN_EXPIRES_IN, expiresIn.toString());
    }

    get currentBrand(): string | undefined {
        return sessionStorage.getItem(this.BRAND) ?? undefined;
    }

    set currentBrand(brand: string | undefined) {
        if(!brand){
            sessionStorage.removeItem(this.BRAND);
            return;
        }

        sessionStorage.setItem(this.BRAND, brand);
    }
  
    get embeddedURL(): string | undefined {
        return sessionStorage.getItem(this.EMBEDDED_URL) ?? undefined;
    }

    set embeddedURL(brand: string | undefined) {
        if(!brand){
            sessionStorage.removeItem(this.EMBEDDED_URL);
            return;
        }

        sessionStorage.setItem(this.EMBEDDED_URL, brand);
    }

    get userArn(): string | undefined {
        return sessionStorage.getItem(this.USER_ARN) ?? undefined;
    }

    set userArn(arn: string | undefined) {
        if(!arn){
            sessionStorage.removeItem(this.USER_ARN);
            return;
        }

        sessionStorage.setItem(this.USER_ARN, arn);
    }
};

export let sessionHelper = new SessionHelper();

